import { Navigate, Route, Routes } from "react-router-dom";
import "../../styles/staff-mobile.css";
import { StaffAvailabilityPage } from "./pages/StaffAvailabilityPage";
import { StaffHomePage } from "./pages/StaffHomePage";
import { StaffMePage } from "./pages/StaffMePage";
import { StaffNotificationPreferencesPage } from "./pages/StaffNotificationPreferencesPage";
import { StaffNotificationsPage } from "./pages/StaffNotificationsPage";
import { StaffShiftDetailPage } from "./pages/StaffShiftDetailPage";
import { StaffShiftsPage } from "./pages/StaffShiftsPage";
import { StaffTimeCorrectionsPage } from "./pages/StaffTimeCorrectionsPage";
import { StaffWorkPage } from "./pages/StaffWorkPage";

export function StaffApp() {
  return (
    <Routes>
      <Route index element={<StaffHomePage />} />
      <Route path="shifts" element={<StaffShiftsPage />} />
      <Route path="shifts/:id" element={<StaffShiftDetailPage />} />
      <Route path="work" element={<StaffWorkPage />} />
      <Route path="me" element={<StaffMePage />} />
      <Route path="me/availability" element={<StaffAvailabilityPage />} />
      <Route path="me/notification-preferences" element={<StaffNotificationPreferencesPage />} />
      <Route path="me/time-corrections" element={<StaffTimeCorrectionsPage />} />
      <Route path="notifications" element={<StaffNotificationsPage />} />
      <Route path="*" element={<Navigate to="/staff" replace />} />
    </Routes>
  );
}
